import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'jquery';
import 'bootstrap';
import axios from 'axios';

import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';


import "./assets/bootstrap/css/bootstrap.css"
import "./assets/porto/css/theme.css"
import "./assets/porto/css/theme-custom.css"
import {messages} from './assets/porto/js/validate.js'

import { getClientTimezoneOffsetInHoursNegative } from './assets/za_libs/timezone.js'

const trumbowyg_config = {
  lang: "fr",
  btns: [
    ['undo', 'redo'], // Only supported in Blink browsers
    ['strong', 'em'],
    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
    ['horizontalRule'],
    ['removeformat'],
    ['fullscreen']
  ],
  autogrow: true,
  resetCss: true
};


Chart.plugins.unregister(ChartDataLabels);

Vue.config.productionTip = false

import moment from 'moment';
moment.locale('fr-CA');
Vue.prototype.moment = moment;

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill(); // support for el.scrollIntoView({ behavior: 'smooth' }), el.scrollTo({ behavior: 'smooth' })

import VueTrumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
import 'trumbowyg/dist/langs/fr.min.js';

Vue.use(VueTrumbowyg);

import Notifications from 'vue-notification';
Vue.use(Notifications);

Vue.prototype.$trumbowygConfig = trumbowyg_config;
Vue.prototype.$messages = messages;
Vue.prototype.$checkApiErrors = function(response) {
  if(response && response.error) {
    this.$notify({type: "error",group: 'std',
            title: 'Server Error',
            text: response.error,
            duration: 5000
    });
    return true;
  }
  if(response && response.success) {
    this.$notify({type: "success",group: 'std',
            title: 'Success',
            text: response.success
    });
  }
  if(response && response.denied_provider) {

    router.push({name:'liste_fournisseurs'}); 
    this.$notify({type: "error",group: 'std',
            title: 'Server Error',
            text: response.denied_provider,
            duration: 5000
    });
    return true;

  }
  if(response && response.denied_service) {

    router.push({name:'liste_fournisseurs'}); 
    this.$notify({type: "error",group: 'std',
            title: 'Server Error',
            text: response.denied_service,
            duration: 5000
    });
    return true;

  }
  if(response && response.denied_dossier) {

    router.push({name:'liste_fournisseurs'}); 
    this.$notify({type: "error",group: 'std',
            title: 'Server Error',
            text: response.denied_dossier,
            duration: 5000
    });
    return true;

  }
  if(response && response.denied_ticket) {

    router.push({name:'liste_billets'}); 
    this.$notify({type: "error",group: 'std',
            title: 'Server Error',
            text: response.denied_ticket,
            duration: 5000
    });
    return true;

  }

  if(response && response.denied_requirement) {

    router.push({name:'liste_fournisseurs'}); 
    this.$notify({type: "error",group: 'std',
            title: 'Server Error',
            text: response.denied_requirement,
            duration: 5000
    });
    return true;

  }
  
  return false;
}

//  in case we reload
axios.defaults.headers.common['X-Custom-Authorization'] = localStorage.jwt;

axios.interceptors.response.use((response) => {return response},
  function (error) {
    // intercept the global error
    // let originalRequest = error.config
    if (error.response.status === 401) {
      router.push({name:'login'}); 
    }
    return Promise.reject(error);
  }
);

axios.interceptors.request.use((config) => {
  config.headers.common['ZA-Client-Timezone-Offset-Hours'] = getClientTimezoneOffsetInHoursNegative();
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

new Vue({
  router,
  render: h => h(App),
  data() { return{
    firstName: "(inconnu)",
    messages:messages,
    server_base: process.env.VUE_APP_server_base || "",
    google_drive_api_key: process.env.VUE_APP_google_drive_api_key || "",
    google_drive_client_id: process.env.VUE_APP_google_drive_client_id || "",
  }},

}).$mount('#app')
